var _mask, _rect, _path, _rect2, _path2, _g, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path3, _path4, _path5, _rect15, _rect16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnsiteDigitalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 53,
    viewBox: "0 0 86 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5963_4441",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.25,
    width: 85,
    height: 52.5359,
    rx: 0.837782
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.25,
    width: 85,
    height: 52.5359,
    rx: 0.837782,
    fill: "white",
    stroke: "#929292",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_5963_4441)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.849609 1.15813C0.849609 0.849667 1.09967 0.599609 1.40813 0.599609H84.5929C84.9014 0.599609 85.1515 0.849668 85.1515 1.15813V5.48667H0.849609V1.15813Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2031,
    y: 1.64453,
    width: 31.693,
    height: 2.7389,
    rx: 0.417357,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1562 1.64453H58.4778C58.7083 1.64453 58.8952 1.83139 58.8952 2.06189V3.96608C58.8952 4.19658 58.7083 4.38343 58.4778 4.38343H56.1562V1.64453Z",
    fill: "#F5C076"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5963_4441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7643 3.09669C57.9522 2.8314 57.8893 2.46405 57.624 2.27622C57.3587 2.0884 56.9914 2.15118 56.8036 2.41652C56.6157 2.68181 56.6785 3.04912 56.9439 3.23695C57.1332 3.371 57.3836 3.38133 57.5833 3.26338L58.0172 3.69473C58.0641 3.74406 58.1421 3.74603 58.1914 3.69917C58.2407 3.65236 58.2427 3.57441 58.1959 3.52508C58.1944 3.52351 58.1929 3.52207 58.1914 3.52059L57.7643 3.09669ZM57.2836 3.13691C57.0739 3.13695 56.904 2.96712 56.9038 2.75748C56.9038 2.54784 57.0736 2.37788 57.2833 2.37779C57.4927 2.3777 57.6625 2.54726 57.6629 2.75663C57.6633 2.96631 57.4936 3.13655 57.2838 3.13691C57.2837 3.13691 57.2837 3.13691 57.2836 3.13691Z",
    fill: "#555555"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 7.75,
    width: 82.5,
    height: 27.5,
    fill: "#E5E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2285,
    y: 11.9434,
    width: 16.0575,
    height: 20.2464,
    rx: 0.208678,
    fill: "#255156"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2285,
    y: 11.9434,
    width: 16.0575,
    height: 20.2464,
    rx: 0.208678,
    fill: "#255156"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2285,
    y: 11.9434,
    width: 16.0575,
    height: 20.2464,
    rx: 0.208678,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9043,
    y: 11.9434,
    width: 16.0575,
    height: 20.2464,
    rx: 0.208678,
    fill: "#255156"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9043,
    y: 11.9434,
    width: 16.0575,
    height: 20.2464,
    rx: 0.208678,
    fill: "#255156"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9043,
    y: 11.9434,
    width: 16.0575,
    height: 20.2464,
    rx: 0.208678,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8.35547,
    y: 15.6094,
    width: 31.693,
    height: 2.7389,
    rx: 0.417357,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8.35547,
    y: 19.1016,
    width: 20.9446,
    height: 2.79261,
    rx: 0.417357,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.35547,
    y: 23.6387,
    width: 20.9446,
    height: 1.04723,
    rx: 0.417357,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8.35547,
    y: 25.3828,
    width: 22.5154,
    height: 1.04723,
    rx: 0.417357,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.35547,
    y: 27.1289,
    width: 13.7885,
    height: 1.04723,
    rx: 0.417357,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78516 45.8808C6.78516 45.7266 6.91019 45.6016 7.06442 45.6016H29.0212C29.1755 45.6016 29.3005 45.7266 29.3005 45.8808V51.1868H6.78516V45.8808Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7422 45.8808C31.7422 45.7266 31.8672 45.6016 32.0214 45.6016H53.9783C54.1325 45.6016 54.2575 45.7266 54.2575 45.8808V51.1868H31.7422V45.8808Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7012 45.8808C56.7012 45.7266 56.8262 45.6016 56.9804 45.6016H78.9373C79.0915 45.6016 79.2165 45.7266 79.2165 45.8808V51.1868H56.7012V45.8808Z",
    fill: "#E5E5E5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1875,
    y: 40.541,
    width: 17.8028,
    height: 1.3963,
    rx: 0.27926,
    fill: "#E5E5E5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6777,
    y: 42.9844,
    width: 10.8213,
    height: 1.3963,
    rx: 0.27926,
    fill: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5963_4441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.56509,
    height: 1.56509,
    fill: "white",
    transform: "translate(56.6797 2.16602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnsiteDigitalIcon);
export default __webpack_public_path__ + "static/media/onsite-digital-icon.b169b6724e8d6bf85434e8b046bc7655.svg";
export { ForwardRef as ReactComponent };